import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type PostDisable2FAResponse = {};

export const usePostDisable2FAMutation = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (data: PostDisable2FAResponse) => void;
    onError?: (error: Error) => void;
  } = {
    onSuccess: undefined,
    onError: undefined,
  }
) => {
  return useMutation({
    mutationFn: async ({ email, code }: { email: string; code: string }) => {
      const { data } = await client.post(`/auth/2fa/totp/disable`, { email, code });

      return data;
    },
    onSuccess,
    onError,
  });
};
